import { ChallengeLevelResponse } from "@edp-models/challenge-level.model";
import { ChallengeAcceptance } from "@edp-models/challenge.model";
import { CollectiveChallengeHistory } from "@edp-models/collective-challenge-history.model";
import { CollectiveChallenge } from "@edp-models/collective-challenge.model";
import { Experiences, OtherExperience } from "@edp-models/experiences.model";

export interface IChallengesState {
    challengesLevels: ChallengeLevelResponse;
    collectiveChallenge: CollectiveChallenge;
    collectiveChallengeHistory: CollectiveChallengeHistory;
    challengeAcceptance: ChallengeAcceptance;
    experiences: Experiences;
    otherEvents: OtherExperience[];
    activeChallenges: CollectiveChallenge[];
    inactiveChallenges: CollectiveChallenge[];
}

export const initialChallengesState: IChallengesState = {
    challengesLevels: null,
    collectiveChallenge: null,
    collectiveChallengeHistory: null,
    challengeAcceptance: { status: false },
    experiences: null,
    otherEvents: null,
    activeChallenges: null,
    inactiveChallenges: null
};
